
import './modules/register-service-worker';
import { branchBar } from '@crasman/branch-bar';
branchBar.init();// See https://www.npmjs.com/package/@crasman/branch-bar for settings

import Header from './modules/veho/header';
import Footer from './modules/veho/footer';
import MobileNavigation from './modules/veho/mobile-navigation';
import {PredictingInputField} from './modules/veho/predicting-input-field';
import modalInit from './modules/veho/modal';
import ExtraInfoDropdown from './modules/veho/extrainfo-dropdown';
import heroInit from './modules/veho/hero';

Header.init();
Footer.init();
MobileNavigation.init();
PredictingInputField.init();
modalInit();
ExtraInfoDropdown.init();

import('./modules/multiselect' as any).then(multiselect => multiselect.default.init());

// Veho Go Video element
if (document.querySelector('.veho-go-video')) {
  import('./modules/veho/veho-go-video-player' as any).then(VehoGoVideoPlayer => {
    const vehoGoVideoPlayer = VehoGoVideoPlayer.default;
    const videoPlayer = new vehoGoVideoPlayer({
      elements: document.querySelectorAll('.veho-go-video'),
      playButtonClass: '.js-veho-go-video-play',
      pauseButtonIcon: '.icon--video-pause-plain',
      playButtonIcon: '.icon--video-play-plain'
    });

    videoPlayer.init();
  })
}

if ( document.querySelector('.js-hero') ) {
  heroInit();
}

if (document.querySelector('#vehicle-search-form')) {
  import('./modules/vehicle-search' as any).then(vehicleSearch => vehicleSearch.default.init());
}

if (document.querySelector('.tabbed-details__nav')) {
  import('./modules/tabbed-details' as any).then(TabNav => TabNav.default.init());
}

if (document.querySelector('.vehicle-image-carousel')) {
  import('./modules/vehicle-image-carousel' as any).then(VICarousel => VICarousel.init());
}

if (document.querySelector('.card-carousel')) {
  import('./modules/card-carousel' as any).then(CCarousel => CCarousel.init());
}

if (document.querySelector('input[type="range"]')) {
  import('./modules/number-range' as any).then(Range => Range.default.init());
}

if (document.querySelector('#funding-calculator')) {
  import('./modules/funding-calculator' as any).then(Calc => Calc.default.init());
}

if (document.querySelector('.js-datepicker')) {
  import('./modules/datepicker' as any).then(Datepicker => Datepicker.default.init());
}

if (document.querySelector('.js-filter-models')) {
  import('./modules/filter-select' as any).then(fs => fs.default.init());
}

if (document.querySelector('.js-private-leasing-calculator')) {
  import('./modules/veho/private-leasing-calculator' as any).then(plc => plc.default.init());
}

if (document.querySelector('.js-private-leasing-settings-list')) {
  import('./modules/veho/private-leasing-settings-list' as any).then(plsl => plsl.default.init());
}

if (document.querySelector('.js-private-leasing-management')) {
  import('./modules/veho/private-leasing-management-ui' as any).then(plmp => {
    const element: HTMLElement = document.querySelector('.js-private-leasing-management')
    const PrivateLeasingManagement = plmp.default;
    const privateLeasingManagement = new PrivateLeasingManagement(element);
    privateLeasingManagement.init();
  });
}

if (document.querySelector('table.orderable')) {
  import('./modules/veho/orderable-table' as any).then(ot => ot.default.init());
}

const fundingFunnels = document.querySelectorAll('.js-funding-funnel');
if (fundingFunnels.length) {
  import('./modules/veho/funding-funnel' as any).then(module => {
    fundingFunnels.forEach(element => {
      const fundingFunnel = new module.FundingFunnel(element);
      fundingFunnel.init();
    })
  });
}

const collapsibles = document.querySelectorAll('.va-collapsible');
if (collapsibles.length) {
  import('./modules/veho/collapsible' as any).then(module => {
    collapsibles.forEach(element => {
      const collapsible = new module.Collapsible(element);
      collapsible.init();
    })
  });
}

if (document.querySelector('[data-reset-input]')) {
  import('./modules/veho/reset-input' as any).then(ri => ri.default.init());
}

if (document.querySelector('[data-conditional-toggle]')) {
  import('./modules/veho/conditional-toggle' as any).then(ct => ct.default.init());
}

if (document.querySelector('.js-veho-go-carousel .glide')) {
  import('./modules/veho/veho-go-card-carousel' as any).then(vgc => vgc.init());
}

if (document.querySelector('.js-veho-go-calculator-toggle')) {
  import('./modules/veho/veho-go-calculator-toggle' as any).then(vgct => vgct.default.init());
}

if (document.querySelector('.js-dynamic-text-input')) {
  import('./modules/veho/dynamic-text-input' as any).then(dti => dti.default.init());
}

if (document.querySelector('a[data-formdata-urlifier]')) {
  import('./modules/veho/formdata-urlifier' as any).then(fu => fu.default.init());
}

const vaFormFields = document.querySelectorAll('.js-va-form-field');
if (vaFormFields.length) {
  import('./modules/veho/form-field' as any).then(module => {
    vaFormFields.forEach(element => {
      const formField = new module.default(element);
    })
  });
}
